import { useEffect, useState } from "react";
import Invoices from "../../Components/FinancesPage/Invoices/Invoices";
import { useAuth } from "../../Providers/AuthProvider";
import UnPaidInvoices from "../../Components/FinancesPage/UnPaidInvoices/UnPaidInvoices";
import { useInvoices } from "../../Providers/InvoicesProvider";
import ScrollUpArrow from "../../Components/Components/ScrollUpArrow";
import NoAccess from "../../Components/NoAccess";
import useCheckUserRole from "../../Components/BasketPage/Hooks/useCheckUserRole.ts";
import { UserRole } from "../../Data/UserRolesEnum.ts";
import ErrorBoundary from "../../Components/ErrorBoundary/ErrorBoundary.jsx";
import InformationErrorModal from "../../Components/Components/Modals/InformationErrorModal.jsx";
import Balance from "../../Components/FinancesPage/Balance/Balance.jsx";
import BalanceItems from "../../Components/FinancesPage/Balance/BalanceItems.jsx";
import { useCustomer } from "../../Providers/CustomerProvider.jsx";
import { useParams } from "../../Providers/ParamsProvider.jsx";
import MobileAccountNavBar from "../../Components/MobileComponents/NavBarMobile.jsx/MobileAccountNavBar.jsx";
import { AccountCurrentView } from "../../Data/PageModeEnums.ts";

const FinancesPageIndex = () => {
  const { authState } = useAuth();
  const [showNoEInvoiceModal, setShowNoEInvoiceModal] = useState(false)
  const [currentUser, setCurrentUser] = useState(authState.user ? authState.user : {});
  const [currentView, setCurrentView] = useState("Bieżące")
  const { unPaidInvoices, archiveInvoices, isLoadingArchive, isLoadingUnPaid, handleGetUnPaid, handleGetArchive } = useInvoices()
  const { isUserHasAccess } = useCheckUserRole()
  const { isMobile } = useParams()
  const { handleGetCreditInfo, isLoadingCredit, creditInfo } = useCustomer()

  useEffect(() => {
    handleGetUnPaid()
    handleGetArchive()
    handleGetCreditInfo()
  }, []);

  useEffect(() => {
    if (currentUser === "") {
      window.location.href = "/login";
    }
  }, [currentUser]);

  useEffect(() => {
  }, [unPaidInvoices])

  if (!isUserHasAccess(UserRole.Finance)) {
    return <NoAccess />
  }
  return (
    <>
      <ErrorBoundary>
        <div>
          <InformationErrorModal
            show={showNoEInvoiceModal}
            setShow={() => setShowNoEInvoiceModal(false)}
            title={'UWAGA'}
            message={'Aby pobierać dokumenty elektronicznie, proszę wyrazić zgodę na e-Faktury. Zgode może wyrazić konto z uprawnieniami administratora w zakładce moje konto.'}
          />
          <ScrollUpArrow />

          <div className="container-fluid-with-paddings mt-4" style={{ marginBottom: isMobile ? '80px' : '0px' }}>
            {isMobile && <div className="mb-2"><MobileAccountNavBar currentKey={AccountCurrentView.Finanse} /></div>}
            <div className="main-container-holder">
              <div className="tabs mb-4">
                <button
                  className={`tab-button ${currentView === "Bieżące" ? "active" : ""
                    }`}
                  onClick={() => setCurrentView("Bieżące")}
                >
                  Płatności bieżące
                </button>
                <button
                  className={`tab-button ${currentView === "Archiwum" ? "active" : ""
                    }`}
                  onClick={() => setCurrentView("Archiwum")}
                >
                  Historia rachunku
                </button>
                <button
                  className={`tab-button ${currentView === "Bilans" ? "active" : ""
                    }`}
                  onClick={() => setCurrentView("Bilans")}
                >
                  Bilans kontrahenta
                </button>
              </div>

              {currentView === "Bieżące" ? (
                <UnPaidInvoices currentView={currentView} invoices={unPaidInvoices} isLoading={isLoadingUnPaid} setShowNoEInvoiceModal={setShowNoEInvoiceModal} />
              ) : currentView === "Archiwum" ? (
                <Invoices currentView={currentView} invoices={archiveInvoices} isLoading={isLoadingArchive} setShowNoEInvoiceModal={setShowNoEInvoiceModal} />
              ) : (
                <Balance creditInfo={creditInfo} />
              )}
            </div>
            {currentView === "Bilans" && <BalanceItems items={creditInfo ? creditInfo.overDue : []} isLoading={isLoadingCredit} />}
          </div>
        </div>
      </ErrorBoundary>
    </>
  )
}

export default FinancesPageIndex;
